import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css/pagination";
import "swiper/css";
import { useEffect, useState } from "react";
import { getReviews } from "../getReviews";

function Reviews({i18n, text, lang}) {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    getReviews().then(setReviews)
  }, [])
  return (true &&
    <div className="block_8">
        <h2>{text["title_8"][lang]}</h2>
        <h6>{text["subtitle_8"][lang]}</h6>
        <div className="swiper_desktop">
          <Swiper
          modules={[Pagination]}
          loop={true}
          pagination={{
            clickable: true,
          }}
          spaceBetween={20}
          slidesPerView={2}
          >
          {reviews.map((review, index) => (
              <SwiperSlide key={index}>
              <div className="review_card">
                  <h3>{review.name?.[lang]}</h3>
                  <div style={{width: review.stars / 5 * 200 + "px"}}></div>
                  <p>{review.text?.[lang]}</p>
              </div>
              </SwiperSlide>
          ))}
          </Swiper>
        </div>
        <div className="swiper_mobile">
          <Swiper
          modules={[Pagination]}
          autoplay={false}
          loop={true}
          pagination={{
            clickable: true,
          }}
          spaceBetween={20}
          slidesPerView={1}
          >
          {reviews.map((review, index) => (
              <SwiperSlide key={index}>
              <div className="review_card">
                  <h3>{review.name?.[lang]}</h3>
                  <div style={{width: review.stars / 5 * 200 + "px"}}></div>
                  <p>{review.text?.[lang]}</p>
              </div>
              </SwiperSlide>
          ))}
          </Swiper>
        </div>
    </div>
  );
}

export default Reviews;